import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useFocusedFeatures } from "../../FocusedFeatures";
import {
  PATH_TAX_WITHHOLDINGS,
  PATH_TAX_WITHHOLDINGS_EDIT_TAX_PROFILE,
  PATH_TAX_WITHHOLDINGS_EDIT_TAX_RATE,
  PATH_TAX_WITHHOLDINGS_SCHEDULE_PAYMENT,
  PATH_TAX_WITHHOLDINGS_SURVEY
} from "./paths";
import { RouteEditTaxProfile } from "./routes/RouteEditTaxProfile";
import { RouteEditTaxRate } from "./routes/RouteEditTaxRate";
import { RouteIndex } from "./routes/RouteIndex";
import { RouteSchedulePayment } from "./routes/RouteSchedulePayment";
import { RouteSurvey } from "./routes/RouteSurvey";

export const TaxWithholdings: React.FC = () => {
  const focusedFeatures = useFocusedFeatures();

  if (!focusedFeatures.showSideNavFinancialBenefits) {
    return <Redirect to="/member/dashboard" />;
  }

  return (
    <Switch>
      <Route path={PATH_TAX_WITHHOLDINGS} exact component={RouteIndex} />
      <Route
        path={PATH_TAX_WITHHOLDINGS_SCHEDULE_PAYMENT}
        component={RouteSchedulePayment}
      />
      <Route
        path={PATH_TAX_WITHHOLDINGS_EDIT_TAX_RATE}
        component={RouteEditTaxRate}
      />
      <Route
        path={PATH_TAX_WITHHOLDINGS_EDIT_TAX_PROFILE}
        component={RouteEditTaxProfile}
      />
      <Route path={PATH_TAX_WITHHOLDINGS_SURVEY} component={RouteSurvey} />

      <Redirect from="*" exact to={PATH_TAX_WITHHOLDINGS} />
    </Switch>
  );
};
